import { colorClassNames, fontWeightClassnames, textClassNames } from './text.constants';

export type RemovePrefix<S extends string, P extends string> = S extends `${P}${infer R}` ? R : S;

export function getTextVariantClassname(
  variant: RemovePrefix<(typeof textClassNames)[number], 'text-'>
): `text-${typeof variant}` {
  return `text-${variant}`;
}

export function getTextColorClassname(
  color: RemovePrefix<(typeof colorClassNames)[number], 'color-'>
): `color-${typeof color}` {
  return `color-${color}`;
}

export function getTextWeightClassname(
  weight: RemovePrefix<(typeof fontWeightClassnames)[number], 'font-'>
): `font-${typeof weight}` {
  return `font-${weight}`;
}
